export enum DatePickerProps {
  FORMAT = 'YYYY-MM-DD',
  YEAR = 'year',
  MONTH = 'month',
  FORMAT_START = 'MM/YYYY',
  FORMAT_RANGE = 'MMMM YYYY',
  FORMAT_NEW = 'MMM YYYY',
  FORMAT_YEAR = 'YYYY',
  JANUARY = 'Jan',
}
